import { render, staticRenderFns } from "./prnpolicyconsult.vue?vue&type=template&id=60404cee"
import script from "./prnpolicyconsult.vue?vue&type=script&lang=js"
export * from "./prnpolicyconsult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports